module.exports = __webpack_public_path__ + "img/guide-body-2-3.f9a5ec92.png";